import React from 'react';
import {
    Image,
    TouchableOpacity,
    View,
    Text,
    TextInput,
    StyleSheet,
    ActivityIndicator,
    ToastAndroid
} from "react-native";

import Modal from './base/Modal';

import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import { ScrollView } from 'react-native-gesture-handler';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import StyledButton from '../StyledButton';
import StyledIcon from '../StyledIcon';
import OrderGroupCard from '../order/OrderGroupCard';
import { SafeJSONObject } from '../../constants/Utils';
import { OrderContext } from '../../contexts/order/Store';
import http from '../../utils/http';

const analytics = new AnalyticsService()

const OrderRatingModal = ({ modalState, hideModal, order }) => {
    const navigation = useNavigation()
    const authContext = React.useContext(AuthContext);
    const buyerData = authContext.getUserData.buyerData;
    const token = authContext.getUserData.userToken;
    const { action: order_fetch } = React.useContext(OrderContext);

    const clickAreaRef = React.useRef()
    const scrollViewRef = React.createRef()
    const messageBodyInputRef = React.createRef()

    const [rating, setRating] = React.useState(null)
    const [body, setBody] = React.useState('')
    const [isSubmitting, setSubmitting] = React.useState(false)

    const submitFeedback = () => {
        setSubmitting(true)
        let requests = []
        let form = new FormData()

        form.append('tag', 'buyer')
        form.append('rater', buyerData._id)
        form.append('rating', rating)
        form.append('order_id', order._id)
        requests.push(http.post('order_rating/create', form, token))

        if (body && body !== '') {
            form = new FormData()
            form.append('flag', 'order')
            form.append('body', body)
            form.append('sender', buyerData.user_id)
            form.append('recipient', '*')
            form.append('status', 'active')
            requests.push(http.post('ticket/create', form, token))
        }

        form = new FormData()
        let _meta = order.meta
        _meta = SafeJSONObject(_meta)
        _meta['rating'] = rating
        _meta['confirmed'] = rating ? 'yes' : 'no'
        _meta['review'] = body

        form.append('_id', order._id)
        form.append('meta', JSON.stringify(_meta))
        requests.push(http.post('order_group/update_meta', form, token))

        Promise
            .all(requests)
            .then(res => {
                const [res_rating, res_ticket, res_update_meta] = res;
                setSubmitting(false);
                order_fetch()
                    .then(res => { })
                    .catch(err => { });

                if (res_rating.code === 200) {
                    analytics.logEvent('Submitted Order Rating', buyerData, {
                        order_id: order._id,
                        order_ref: order.ref,
                        rating: rating,
                    })
                    if (res_ticket) {
                        if (res_ticket.code === 200) {
                            analytics.logEvent('Submitted Order Review', buyerData, {
                                order_id: order._id,
                                order_ref: order.ref,
                                review: body,
                            })
                            // ToastAndroid.show('Thanks for sharing your experience with us.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                            hideModal()
                        } else {
                            // ToastAndroid.show(res_ticket.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                            hideModal()
                        }
                    } else {
                        // ToastAndroid.show('Thanks for your rating.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                        hideModal()
                    }
                } else {
                    // ToastAndroid.show(res_rating.message, ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                    hideModal()
                }
            })
            .catch(err => {
                setSubmitting(false)
                console.log(err)
                // ToastAndroid.show('An error occured. Please try again.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            })
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                if (!isSubmitting) {
                    hideModal()
                }
            }
        }
    }

    React.useEffect(() => {
        if (rating) {
            try {
                // messageBodyInputRef.current.focus()
                // setTimeout(scrollViewRef.current.scrollToEnd, 2000)
                submitFeedback()
            } catch (e) {
                console.log(e)
            }
        }
    }, [rating])

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={[styles.overlay]}
            >

                {
                    rating !== null
                        ? <TouchableOpacity
                            style={styles.closeButton}
                            onPress={submitFeedback}
                            disabled={isSubmitting || rating === null}
                        >
                            {
                                isSubmitting
                                    ? <ActivityIndicator
                                        size={36}
                                        color={`${Colors.darkColor}1A`}
                                    />
                                    : <StyledIcon
                                        iconName="md-close"
                                        iconColor="#070B1FA1"
                                        fillColor={`${Colors.darkColor}1A`}
                                        size={36}
                                    />
                            }
                        </TouchableOpacity>
                        : null
                }
                <ScrollView ref={scrollViewRef} contentContainerStyle={styles.container}>

                    <View style={[styles.card]}>

                        <View style={[
                            styles.cardBody,
                            {
                                marginVertical: 20
                            }
                        ]}>
                            <Text style={styles.headerText}>Help us make</Text>
                            <Text style={styles.headerText}>your next delivery better</Text>
                        </View>

                        <OrderGroupCard
                            navigation={navigation}
                            order={order}
                            readOnly={true}
                            hideConfirmButton
                        />

                        <View style={[styles.cardBody, {
                            marginTop: 40,
                        }]}>
                            <Text style={styles.subHeaderText}>How was your delivery?</Text>

                            <TouchableOpacity style={[styles.ratingButton, rating === 3 && styles.ratingButtonActive]} disabled={isSubmitting} onPress={() => { setRating(3) }}>
                                <Image source={require('../../assets/images/main/rating_4.png')} width={24} height={24} />
                                <Text style={styles.ratingText}>Excellent</Text>
                            </TouchableOpacity>
                            <TouchableOpacity style={[styles.ratingButton, rating === 2 && styles.ratingButtonActive]} disabled={isSubmitting} onPress={() => { setRating(2) }}>
                                <Image source={require('../../assets/images/main/rating_3.png')} width={24} height={24} />
                                <Text style={styles.ratingText}>Good</Text>
                            </TouchableOpacity>
                            <TouchableOpacity style={[styles.ratingButton, rating === 1 && styles.ratingButtonActive]} disabled={isSubmitting} onPress={() => { setRating(1) }}>
                                <Image source={require('../../assets/images/main/rating_2.png')} width={24} height={24} />
                                <Text style={styles.ratingText}>Bad</Text>
                            </TouchableOpacity>
                            <TouchableOpacity style={[styles.ratingButton, rating === 0 && styles.ratingButtonActive]} disabled={isSubmitting} onPress={() => { setRating(0) }}>
                                <Image source={require('../../assets/images/main/rating_1.png')} width={24} height={24} />
                                <Text style={styles.ratingText}>Order was not delivered</Text>
                            </TouchableOpacity>

                        </View>

                        {
                            rating !== null &&
                            false
                                ? <View style={[
                                    styles.cardBody, {
                                        marginTop: 30,
                                    }]
                                }>
                                    <Text style={styles.subHeaderText}>How was your last delivery?</Text>

                                    <TextInput
                                        ref={messageBodyInputRef}
                                        placeholder="Help us make your next delivery better."
                                        multiline={true}
                                        numberOfLines={4}
                                        value={body}
                                        onChangeText={text => setBody(text)}
                                        onFocus={() => {
                                            try {
                                                scrollViewRef?.current?.scrollToEnd()
                                            } catch (e) {
                                                //
                                            }
                                        }}
                                        style={{
                                            backgroundColor: Colors.whiteColor,
                                            paddingHorizontal: 15,
                                            paddingVertical: 11,
                                            flexGrow: 1,
                                            ...FontStyles.dark,
                                            ...FontStyles.size15,
                                            ...FontStyles.lh18,
                                            ...FontStyles.normal,
                                            textAlignVertical: 'top',
                                        }}
                                    />

                                    <StyledButton
                                        label="Submit"
                                        action={submitFeedback}
                                        disabled={isSubmitting || rating === null}
                                        submitting={isSubmitting}
                                        style={{
                                            marginTop: 30,
                                        }}
                                    />
                                </View>
                                : null
                        }
                    </View>
                </ScrollView>
            </View>
        </Modal>
    )
}

export default OrderRatingModal

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.6)',
    },
    container: {
        // flex: 1,
        flexGrow: 1,
        justifyContent: 'flex-start',
        // position: "relative"
    },
    closeButton: {
        position: 'absolute',
        flexDirection: 'row',
        alignSelf: 'flex-end',
        paddingHorizontal: 16,
        paddingVertical: 6,
        top: 6,
        zIndex: 1
    },
    closeButtonText: {
        color: '#070B1F',
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        flexGrow: 1,
        backgroundColor: '#F6F7FC',
        paddingTop: 10,
        paddingBottom: 16,
    },
    cardBody: {
        paddingHorizontal: 16
    },
    cardBodyText: {
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
    },
    headerText: {
        color: Colors.shades._2,
        ...FontStyles.size22,
        ...FontStyles.lh28,
        ...FontStyles.normal,
    },
    subHeaderText: {
        color: Colors.shades._7,
        ...FontStyles.size16,
        ...FontStyles.lh20,
        ...FontStyles.normal,
        marginBottom: 6,
    },
    ratingButton: {
        flexDirection: 'row',
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderColor: Colors.shades._3,
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 6,
        backgroundColor: Colors.whiteColor,
        alignItems: 'center',
        marginBottom: 10,
    },
    ratingButtonActive: {
        backgroundColor: 'rgba(59, 84, 236, 0.1)',
        borderColor: 'rgba(59, 84, 236, 0.1)'
    },
    ratingText: {
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh18,
        ...FontStyles.normal,
        marginLeft: 10,
    }
})